import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Instagram, Linkedin, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About */}
          <div>
            <Link to="/" className="flex items-center mb-4 group">
              <img 
                src="https://customer-assets.emergentagent.com/job_roadwise-asia/artifacts/8tbwewte_THI%20Logo%202024.png" 
                alt="The Highland Institute" 
                className="h-12 w-auto transition-transform group-hover:scale-105 brightness-0 invert"
              />
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed">
              Promoting sustainable futures through indigenous knowledge systems, community engagement, and rigorous academic inquiry.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/about" className="text-gray-400 hover:text-green-400 transition-colors">About Us</Link></li>
              <li><Link to="/research" className="text-gray-400 hover:text-green-400 transition-colors">Research</Link></li>
              <li><Link to="/programmes" className="text-gray-400 hover:text-green-400 transition-colors">Programmes</Link></li>
              <li><Link to="/library" className="text-gray-400 hover:text-green-400 transition-colors">Library</Link></li>
              <li><Link to="/events" className="text-gray-400 hover:text-green-400 transition-colors">Events</Link></li>
            </ul>
          </div>

          {/* Research Projects */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Research Projects</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/research/ekologos" className="text-gray-400 hover:text-green-400 transition-colors">Ekologos</Link></li>
              <li><Link to="/research/myclimate" className="text-gray-400 hover:text-green-400 transition-colors">MyCClimate</Link></li>
              <li><Link to="/research/plurimed" className="text-gray-400 hover:text-green-400 transition-colors">PluriMed</Link></li>
              <li><Link to="/research/earthkeepers" className="text-gray-400 hover:text-green-400 transition-colors">Earthkeepers</Link></li>
              <li><Link to="/research" className="text-gray-400 hover:text-green-400 transition-colors">All Projects</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Contact Us</h4>
            <ul className="space-y-3 text-sm text-gray-400">
              <li className="flex items-start space-x-2">
                <MapPin className="w-4 h-4 mt-1 flex-shrink-0 text-green-500" />
                <span>
                  The Highland Institute<br />
                  Meluri Road<br />
                  Kohima, Nagaland<br />
                  797001, India
                </span>
              </li>
              <li className="flex items-center space-x-2">
                <Phone className="w-4 h-4 flex-shrink-0 text-green-500" />
                <a href="tel:+917005605596" className="hover:text-green-400 transition-colors">
                  +91 700 560 5596
                </a>
              </li>
              <li className="flex items-center space-x-2">
                <Mail className="w-4 h-4 flex-shrink-0 text-green-500" />
                <a href="mailto:info@highlandinstitute.org" className="hover:text-green-400 transition-colors">
                  info@highlandinstitute.org
                </a>
              </li>
            </ul>
            <div className="flex space-x-3 mt-4">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="p-2 bg-gray-800 rounded-full hover:bg-green-600 transition-colors">
                <Facebook className="w-4 h-4" />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="p-2 bg-gray-800 rounded-full hover:bg-green-600 transition-colors">
                <Twitter className="w-4 h-4" />
              </a>
              <a href="https://instagram.com/highlandinstitute" target="_blank" rel="noopener noreferrer" className="p-2 bg-gray-800 rounded-full hover:bg-green-600 transition-colors">
                <Instagram className="w-4 h-4" />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="p-2 bg-gray-800 rounded-full hover:bg-green-600 transition-colors">
                <Linkedin className="w-4 h-4" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 text-sm text-gray-400 text-center">
          <p>&copy; {new Date().getFullYear()} The Highland Institute. All rights reserved.</p>
          <div className="flex justify-center space-x-6 mt-4">
            <Link to="/privacy" className="hover:text-green-400 transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-green-400 transition-colors">Terms of Use</Link>
            <Link to="/accessibility" className="hover:text-green-400 transition-colors">Accessibility</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;